<template>
<ValidationObserver ref="observer">
  <form ref="add_dp_amount_form" @submit.prevent="addPaymentPlan">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50">
            <validation-provider rules="planname" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Plan Name</label>
              <md-input v-model="payment_plan_name" required/>
              <validation-error :errors="apiValidationErrors.payment_plan_name" />
            <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
            <!-- <validation-provider rules="plantype" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Plan Type</label>
              <md-select v-model="payment_plan_type" required >
                <md-option value="1">Yellow Plate</md-option>
                <md-option value="2">Black Plate</md-option>
                <md-option value="3">Black Plate Ownership</md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.payment_plan_type" />
            <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider> -->
            <validation-provider rules="vehicletype" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Vehicle Type</label>
              <md-input v-model="payment_plan_vehicle_type_view" required readonly/>
              <validation-error :errors="apiValidationErrors.dp_amount_vehicle_type" />
              <md-button style="background-color:green;" class="md-icon-button md-info md-dense" v-on:click="findVehicleType">
                <md-icon >search</md-icon>
              </md-button>
            <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>

                <div class="md-layout-item md-size-50">
                  <div class="field column">
                <div class="control">
              <autoextra :collection="paymentplanweek" v-slot="{item,last,index}">
              <div  :class="{last: last}">
                <div v-if="item.payment_plan_installment_week || item.payment_plan_installment_week==0 || last" class="columns">
                <label style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Installment {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Week No</label>
                      <md-input type="text" v-on:keypress="NumbersOnly"  v-model="item.payment_plan_installment_week" :readonly="index==0" @wheel="$event.target.blur()" min=2 oninput="validity.valid||(value='');" required/>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
            <validation-provider ref="payment_plan_week_installment" v-slot="{ errors }">
                    <md-field >
                      <label class="label" >Installment</label>
                      <md-input type="text" v-on:keypress="NumbersOnly"  v-model="item.payment_plan_installment_amount" @wheel="$event.target.blur()" min=1 oninput="validity.valid||(value='');" required/>
            <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
            </validation-provider>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="index !=0 && item.payment_plan_installment_week ">
                    delete
                  </md-button>
                </md-card-actions>
                </div>            
              </div>
              </div>
            </autoextra>
            </div>
                  </div>
                </div>
            </div>


        
      </md-card-content>
      <modal ref="modalListVehicleType" class="coba">
        <template v-slot:header>
          <div>
            <h3>List Vehicle</h3>
          </div>
          <md-button class="md-dense md-round md-icon-button" @click="CloseList()"><md-icon>close</md-icon></md-button>
        </template>
        
        <template v-slot:body>
          <list-vehicle-type :data_id="$refs.modalListVehicleType.data"/>
        </template>
      </modal>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import ListVehicleType from "@/pages/Dashboard/Fms/PaymentPlan/Modal/ListVehicleType.vue";
import { Modal } from "@/components";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import  Autoextra  from 'vue-autoextra';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('planname', {
  ...required,
  message: 'Name Field is required'
});
extend('vehicletype', {
  ...required,
  message: 'Vehicle Type field is required'
});
extend('plantype', {
  ...required,
  message: 'Payment Plan Type field is required'
});

extend('week', {
  ...required,
  message: 'Vehicle Type field is required'
});
  
  export default {
     name: "add-payment-plan",

    props: [
      'payment_plan'
    ],

    // props:{
    //   payment_plan: null,
    // },

    components: {ValidationError, ValidationObserver, Modal, "list-vehicle-type" : ListVehicleType , Autoextra},

    mixins: [formMixin],

    data() {
    return {
      paymentplanweek: [{payment_plan_installment_amount: "1",payment_plan_installment_week: "1"}],
      payment_plan_vehicle_type_view: null,
      payment_plan_name: null,
      payment_plan_type: null,
    };
  },

    // created() {
    //   this.getLastNo();
    // },

  
    methods: {

      // fungsi untuk tombol direct ke list Payment Plan
      backtoList(id) {
      this.$router.replace({ name: 'List Payment Plan' })
    },

    findVehicleType(){
      this.$refs.modalListVehicleType.openModal()
    },

    modalCloseListVehicleType(data,brand){
      console.log(data)
      if(data.id){
       this.payment_plan_vehicle_type_id = data.id
       this.payment_plan_vehicle_type_view = brand+' '+ data.vehicle_model +'-'+  data.vehicle_year_model
      }
      this.$refs.modalListVehicleType.closeModal()
    },

    CloseList(){
      this.$refs.modalListVehicleType.closeModal();
    },

    deleteColumn(index){
        if (index > -1) {
           this.paymentplanweek.splice(index, 1)
        }
        
      },

     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addPaymentPlan()
          }
        });
    },


    // onChangePaymentPlan(){
    //   var filter = this.paymentplanweek.filter(function(el) {
    //        console.log(el);
    //         return el != null;
    //       });
    //       console.log(filter)
    //       var int= 0
    //       for (const [key, value] of Object.entries(filter)) {
    //                     console.log(key);
    //                     console.log(value);
    //                     if(!value.payment_plan_week  && value.payment_plan_week != 0){
    //                       int++
    //                     }
    //                     else{
    //                       console.log(key-int);
    //                       this.$set(this.paymentplanweek, key-int, {
    //                          id : value.id,
    //                         payment_plan_week : value.payment_plan_week,
    //                         payment_plan_week_installment : value.payment_plan_week_installment,
                            
    //                       });
    //                       if(int!=0){
    //                         this.$set(this.paymentplanweek, key, {
    //                            id :null,
    //                           payment_plan_week : null,
    //                           payment_plan_week_installment : null
                              
    //                         });
    //                       }
                          
    //                       int= 0
    //                     }
                        

    //                   }
      
    // },

// async validateForm() {
//       const vehicle_document_type = this.$refs['vehicle_document_type'];
      
//       let result = []
//       if(Object.keys(this.paymentplanweek).length != 0){
//         for (const [key, value] of Object.entries(this.paymentplanweek)) {
//           if((value.payment_plan_week || value.payment_plan_week == 0) && !value.payment_plan_week_installment){
            
//             result.push(false)
//           }
//         }
//       }
// },

      NumbersOnly(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },


    // fungsi add data
      async addPaymentPlan() {
       
        console.log(this.paymentplanweek);
        const data = {
          type: "fms_payment_plans",
          // client_no: this.client_no,
          payment_plan_name: this.payment_plan_name,
          // payment_plan_type: this.payment_plan_type,
          
          payment_plan_type: 1,
          payment_plan_vehicle_type_id: this.payment_plan_vehicle_type_id,
          payment_plan_installment: this.paymentplanweek
        }


        try {
        await this.$store.dispatch("fms_payment_plan/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.replace({name: 'List Payment Plan'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
<style lang="scss" scoped>
.coba {
  width: 800px !important;
  margin: 50px auto !important;
  top: auto !important;
  bottom: auto !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}
</style>
